import styled from 'styled-components';

const Image = styled.div`
    background-image: ${({ url }) => `url(${url})`};
    width: 100%;
    margin:0 auto;
    background-size: cover;
    background-position: center center;
    padding-bottom:100%;
`;

export default Image;



// WEBPACK FOOTER //
// ./src/pages/BlogArticle/BlogAuthor/Image.jsx